/**
 * @file auth.ts
 * @description Authentication service - bridges Clerk and RTK Query
 *
 * Following the White Rabbit: Single source of truth for auth
 * - Clerk manages authentication (sessions, tokens)
 * - This module provides stable access for non-React contexts (RTK Query)
 * - No token storage in Redux (Clerk is the source of truth)
 */

type GetTokenFunction = () => Promise<string | null>

let clerkGetToken: GetTokenFunction | null = null

/**
 * Initialize auth service with Clerk's getToken function
 * Called once during app boot from a component with Clerk context
 */
export function initializeAuth(getToken: GetTokenFunction) {
  clerkGetToken = getToken
}

/**
 * Get authentication token for API calls
 * Used by RTK Query prepareHeaders
 *
 * @returns Promise resolving to auth token or null
 */
export async function getAuthToken(): Promise<string | null> {
  if (!clerkGetToken) {
    console.warn("[Auth] Clerk getToken not initialized")
    return null
  }

  try {
    return await clerkGetToken()
  } catch (error) {
    console.error("[Auth] Failed to get token from Clerk:", error)
    return null
  }
}
